"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
var ZipSearch = /** @class */ (function (_super) {
    __extends(ZipSearch, _super);
    function ZipSearch() {
        var _this = _super.call(this, constants_1.DATA_ZIP_FORM) || this;
        if (!_this.getElement())
            return _this;
        _this.formElement = _this.getElement();
        _this.zipCode = _this.getElement().querySelector("[".concat(constants_1.DATA_ZIPCODE, "]"));
        _this.responseZip = _this.getElement().querySelector("[".concat(constants_1.DATA_ZIP_RESPONSE, "]"));
        _this.responseZip.classList.add(constantsClasses_1.CLASS_HIDDEN);
        _this.initEventListeners();
        return _this;
    }
    /**
     * Init listeners
     * @private
     */
    ZipSearch.prototype.initEventListeners = function () {
        var _this = this;
        this.formElement.addEventListener('submit', function (e) {
            e.preventDefault();
            _this.validateZip();
        });
    };
    ZipSearch.prototype.validateZip = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url, formData;
            var _this = this;
            return __generator(this, function (_a) {
                if (this.zipCode.value.length == 0) {
                    this.zipCode.parentElement.classList.add('form__error');
                    this.responseZip.classList.add(constantsClasses_1.CLASS_HIDDEN);
                }
                else {
                    url = this.formElement.getAttribute(constants_1.DATA_ZIP_FORM);
                    formData = new FormData(this.formElement);
                    this.responseZip.classList.add(constantsClasses_1.CLASS_HIDDEN);
                    fetch(url, {
                        method: 'POST',
                        body: formData
                    })
                        .then(function (response) {
                        return response.text();
                    })
                        .then(function (result) {
                        _this.responseZip.classList.add(constantsClasses_1.CLASS_ACTIVE);
                        _this.responseZip.innerHTML = result;
                        _this.zipCode.parentElement.classList.remove('form__error');
                        _this.responseZip.classList.remove(constantsClasses_1.CLASS_HIDDEN);
                    })
                        .catch(function (e) {
                        console.log(e);
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return ZipSearch;
}(AbstractComponent_1.default));
exports.default = ZipSearch;
